import ResourceTyped from 'Resources/ResourceTyped';

/** Looker ids are strings, and not all of them are numeric. Only these two fields are read. */
type Look = {
	id: string;
	title: string;
};

/**
 * A single saved Looker visualisation, as opposed to a dashboard of several. `/looker/looks`
 * is a `type: 'list'` route behind `requireFeature('looker')`; the inherited `find()` sends no
 * filters and produces the trailing slash the route regex allows, same as `WhatIsMyIp.ts`.
 */
class LookerLook extends ResourceTyped<Look> {
	constructor() {
		super('looker/looks');
	}
}

const resource = new LookerLook();

export default resource;
